<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid menu">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="#" style="color:#ffffff;">
          <b> <img src="../../../assets/img/user.svg" style="width:30px;margin-bottom:10px;"> {{ userCode+","}}</b> {{$t("logon_welcom") }}!
        </a>
      </div>

      <div class="collapse navbar-collapse menu" id="bs-example-navbar-collapse-1" style="background-color: #18b832;">
        <ul class="nav navbar-nav">
          <li v-for="(menu,index) in menus" :key="index" :class="{'dropdown menu_select':menu.children.length>0}">
            <a v-if="menu.name.length==0" href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" style="color:#ffffff;">
              <img :src="menu.imgUrl" style="width:30px;">
              {{$t(menu.text)}}
              <span class="caret"></span>
            </a>
            <a v-if="menu.name.length>0" href="javascript:;" @click="gotoPage(menu)" style="color:#ffffff;">
              <img :src="menu.imgUrl" style="width:30px;" v-if="menu.name!='login'">
              <img :src="menu.imgUrl" style="width:20px;" v-if="menu.name=='login'">

              {{$t(menu.text)}}

            </a>
            <ul v-if="menu.children.length>0" class="dropdown-menu">
              <li v-for="(childrenMenu,index) in menu.children" :key="index">

                <a href="javascript:;" @click="gotoPage(childrenMenu)">
                  <img :src="childrenMenu.imgUrl" style="width:30px;margin-bottom:10px;">
                  {{$t(childrenMenu.text)}}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapMutations } from "vuex";
import { SET_LOGIN_USER } from "@/store/mutation-types";
export default {
  data () {
    return {
      menus: [],
    };
  },
  mounted () {
    if (this.$store.getters.user === null) {
      return;
    }
    this.menus = [
      // {
      //   name: "",
      //   text: "inquiry",
      //   imgUrl:require('@/assets/img/search.svg'),
      //   children: [
      //     { name: "user-awb-query", text: "user" ,imgUrl:require('@/assets/img/search.svg') },
      //     { name: "upload-invoice-purchase-order", text: "upload_INV_PO",imgUrl:require('@/assets/img/upload.svg') },
      //   ],
      // },
      {
        name: "",
        text: "inquiry",
        imgUrl: require('@/assets/img/searchsz.svg'),
        children: [
          { name: "user-awb-query", text: "user", imgUrl: require('@/assets/img/searchsz.svg') },
          { name: "upload-invoice-purchase-order", text: "upload_INV_PO", imgUrl: require('@/assets/img/upload.svg') },
        ],
      },
      //   {
      //   name: "",
      //   text: "inquiry",
      //   imgUrl:require('@/assets/img/search-green.svg'),
      //   children: [
      //     { name: "user-awb-query", text: "user" ,imgUrl:require('@/assets/img/search.svg') },
      //     { name: "upload-invoice-purchase-order", text: "upload_INV_PO",imgUrl:require('@/assets/img/upload.svg') },
      //   ],
      // },

      { name: "user-actions-imex-report", text: "IM_EX_Report", children: [], imgUrl: require('@/assets/img/tradingdata.svg') },
      { name: "Quarterly_Report", text: "Quarterly_Report", children: [], imgUrl: require('@/assets/img/iconnormal.svg') },
      { name: "Monthly_report", text: "Monthly_report", children: [], imgUrl: require('@/assets/img/baobiao.svg') },
      { name: "login", text: "logon_out_01", children: [], imgUrl: require('@/assets/img/logout.svg') },
    ];
  },
  methods: {
    ...mapMutations([SET_LOGIN_USER]),
    gotoPage (menu) {
      if (menu.name == "login") {
        this.SET_LOGIN_USER(null);
      }
      this.$router.push({ name: menu.name });
    },
  },
  computed: {
    userCode () {
      var user = this.$store.getters.user;
      return user ? user.userCode : this.i18n.t("logon_guest");
    },
  },
};
</script>
<style lang="scss" scoped>
.container-fluid {
  background-color: #18b832;
  color: #ffffff;
}
.menu_select:hover .dropdown-menu {
  display: block;
  z-index: 10001;
}

.navbar-nav > li > a {
  padding-top: 0px;
  padding-bottom: 0px;
  line-height: 40px;
}

.nav > li > a {
  padding-top: 0px;
  padding-bottom: 0px;
  line-height: 40px;
}
.navbar-default .navbar-nav > li > a:hover {
  color: #18b832;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  color: #ffffff;
  background-color: #18b832;
}
.dropdown-menu > li > a:hover {
  color: #18b832;
}
.navbar {
  min-height: 30px;
  line-height: 30px;
  margin-top: 10px;
}
.navbar-brand {
  padding: 0px 15px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
}
.navbar-nav > li > a > img {
  margin-bottom: 10px;
}
</style>